import { useState, useEffect, useRef } from "react";
import { Modal } from "react-bootstrap";
import servicosSetor from "../../servicos/servicos-setor";
import { Form } from "semantic-ui-react";
import MenuLateral from "../components/MenuLateral";
import NavMenu from "../components/Nav";
import { ToastContainer, toast } from 'react-toastify';
import Edit from "../../img/svgs/Edit";
import Cancel from "../../img/svgs/Cancel";
import Salvar from "../../img/svgs/Salvar";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { localizedTextsMap } from "../../utils/localizedTextsMap";

const ListSetores = () => {
  const [setores, setSetores] = useState([]);
  const [valor, setValor] = useState();
  const [editado, setEditado] = useState(false)
  const [show, setShow] = useState(false);
  const containerRef = useRef(null);
  const [idSetor, setIdSetor] = useState();
  const nome_setor = useRef();
  const handleClose = () => setShow(false);
  const [showConfirmacao, setShowConfirmacao] = useState(false);
  const [invalido, setInvalido] = useState(false);
 
  const handleCloseConfirmacao = () => {
    setShowConfirmacao(false);
  } 
  
  useEffect(() => {
    function getDados() {
      servicosSetor.listarTodos()
        .then(response => {
          if (response.status === 200) {
            setSetores(response.data);
          }
        }).catch((error) => {
          console.log(error);
        });
    }
    getDados();
  }, [editado]);
 
  const handleShow = (setor) => {
    setInvalido(false);
    setValor(setor);
    setIdSetor(setor.id_setor);
    setShow(true);
  }

  const handleShowConfirmacao = () => {
    const nome = document.querySelector("#nome_setor");

    if(String(nome.value).length < 2){
      setInvalido(true);
    }else{
      setInvalido(false);
      setShow(false);
      setShowConfirmacao(true);
    }
  }
 
  const editarSetor = (nome) => {
    setEditado(false);
    const data = {
      "nome_setor": nome
    }
    servicosSetor.editar(idSetor, data).then(response => {
      if (response.status === 200) {
        setEditado(true);
        toast.success("Setor alterado com sucesso!", {
          theme: "colored",
        });
        setShowConfirmacao(false);
      }
    }).catch(error => {
      console.log(error);
      toast.error("Não foi possível alterar o Setor!", {
        theme: "colored"
      });
      setShowConfirmacao(false);
    })
    handleClose()
  }

  const columnsSetores = [
    { field: "id_setor", headerName: "ID", width: 45 },
    {
      field: "nome_setor",
      headerName: "Nome",
      width: 250,
      editable: true,
    },
    {
      field: "operacao",
      headerName: "Editar",
      width: 90,
      renderCell: (params) => {
        return <button className="btn-icones rounded p-1" size="sm" onClick={() => handleShow(params.row)}><Edit /> Editar</button>
      }
    }
  ];

  const ModalConfirmacao = (props) => {
    return <>
      <div >
        <Modal className="modal-confirmacao" show={showConfirmacao} onHide={handleCloseConfirmacao}>
            <Modal.Body className="">
              <span>Você deseja alterar o nome do setor para <strong>{props.nome}</strong>?</span>
            </Modal.Body>
            <Modal.Footer >
              <button type="button" className="btn-icones rounded p-1 w-25" onClick={() => editarSetor(props.nome)}><Salvar /> Confirmar</button>
              <button type="button" className="btn-icones rounded p-1 w-25" onClick={handleCloseConfirmacao}><Cancel /> Voltar</button>
            </Modal.Footer>
        </Modal>
      </div>
    </>
  }

  const ModalEditar = () => {
    return <>
      <Modal className="modal-mae  modal-lg" show={show} onHide={handleClose}>
        <Modal.Body className="modal-edicao" >
          <div ref={containerRef}>
            <Form>
              <div className="d-flex justify-content-center">
                <div>
                  <Form.Field className="mx-5">
                    <label htmlFor="nome_setor" className="form-label label-texto">Nome</label>
                    <input className="input-cadastro" id="nome_setor" defaultValue={valor?.nome_setor} ref={nome_setor}></input>
                  </Form.Field>
                  {invalido && <p className="errosValidacao">Requerido mínimo 2 letras</p>}
                  <div className="text-center">
                     <button className="btn-icones rounded p-1 w-25 me-4" onClick={handleShowConfirmacao}>
                      <Salvar /> Salvar
                    </button> 
                    <button className="btn-icones rounded p-1 w-25" variant="secondary" onClick={handleClose}>
                      <Cancel /> Cancelar
                    </button>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </Modal.Body>
      </Modal>
    </>
  }
  return (
    <>
      <NavMenu />
      <ModalConfirmacao className="modal-confirmacao" nome={nome_setor?.current?.value} />
      <ToastContainer />
      <div className="d-flex container">
        <div className="w-25">
          <MenuLateral/>
        </div>
        <div className="w-75 tabelas-gerenciais">
          <ModalEditar />
              <h3 className="text-start subtitulo" style={{fontSize: 20}}>Lista de Setores</h3>

              <Box sx={{ height: 650, width: 950, marginTop: 2 }}>
                <DataGrid

                  style={{ borderRadius: "20px" }}
                  localeText={localizedTextsMap}
                  rows={setores}
                  columns={columnsSetores}
                  pageSize={10}
                  rowsPerPageOptions={[10]}
                  disableSelectionOnClick
                  getRowId={(row) => row.id_setor}
                  getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'
                  }
                />
              </Box>
            

          
        </div>
      </div>
    </>
  );
};

export default ListSetores;